import React from "react";
import Layout from "../../components/global/Layout";


const NotFoundPage = ({ history }) => (
  <Layout styleId="not-found-section">
    <div className="not-found-parent">
      <h6>Not Found</h6>
    </div>
  </Layout>
);

export default NotFoundPage;
